import axios from 'axios';
import {
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  SET_LOADING,
  CLEAR_ERROR,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  SET_USER_LOADING,
  CLEAR_USER_ERROR,
  DEV_USER_LOGIN_SUCCESS,
  DEV_USER_LOGIN_FAIL,
} from '../reducers/types';
import { returnError, returnConfig, tokenConfig } from './actionHelperFunc';
const authUrl = '/api/portal';

export const getAdminProfile = (queryData) => async (dispatch) => {
  try {
    // dispatch({ type: CLEAR_ERROR });
    // dispatch({ type: SET_LOADING });

    const config = returnConfig();
    const { data } = await axios.post(
      `${authUrl}/getAdminProfile`,
      queryData,
      config
    );

    dispatch({ type: USER_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: USER_DETAILS_FAIL, payload: returnError(error) });
  }
};

export const loginAdmin = (newUser) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_ERROR });
    dispatch({ type: SET_LOADING });

    const config = returnConfig();
    const { data } = await axios.post(`${authUrl}/adminLogin`, newUser, config);

    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: USER_LOGIN_FAIL, payload: returnError(error) });
  }
};

// USER RELATED ACTIONS
export const getUser = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_USER_ERROR });
    dispatch({ type: SET_USER_LOADING });

    const { data } = await axios.get(
      `${authUrl}/profile`,
      tokenConfig(getState)
    );
    // console.log('data from get user', data);
    dispatch({
      type: GET_USER_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({ type: GET_USER_FAIL, payload: returnError(error) });
  }
};

export const loginDev = (user) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_ERROR });
    dispatch({ type: SET_LOADING });

    const config = returnConfig();
    const { data } = await axios.post(`/api/auth/login`, user, config);

    dispatch({ type: DEV_USER_LOGIN_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DEV_USER_LOGIN_FAIL, payload: returnError(error) });
  }
};

export const loginSuperAdmin = (user) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_ERROR });
    dispatch({ type: SET_LOADING });

    const config = returnConfig();
    const { data } = await axios.post(`/api/auth/super/login`, user, config);

    dispatch({ type: DEV_USER_LOGIN_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DEV_USER_LOGIN_FAIL, payload: returnError(error) });
  }
};
